function Checkbox({ name, description, defaultChecked, onChange }) {
    return (
        <div className={name}>
            <p>{description}</p>
            <input 
                type="checkbox" 
                name={name} 
                defaultChecked={defaultChecked}
                onChange={onChange}
            />
        </div>
    )
}

export default Checkbox